/**
 * Checks validity of props object from a component
 */
export default (componentName: string, props: { [key: string]: any }) => {
  let isValid = true;
  if (process.env.NODE_ENV === 'development') {
    Object.keys(props).map((prop) => {
      if (!props[prop]) {
        const msg = `${componentName}: ${prop} not declared`;
        // eslint-disable-next-line no-console
        console.log(
          '%c' + msg,
          'color: #000; background-color: #FFAE42; padding: 8px 16px; border-radius: 2px;'
        );
        isValid = false;
      }
    });
  }
  return isValid;
};
